import React from "react";
import { usePlaidLink } from "react-plaid-link";
import useSWR from "swr";
import { Grid, Button } from "@mui/material";
import { Accel } from "../../api/accel"; // Adjust the import path as necessary
import { useAccelContext } from "../../contexts/AccelContext/AccelContext"; // Adjust the import path as necessary

export const ConnectBankAccount = () => {
  const { apiUrl, auth, companyId, theme } = useAccelContext();
  const { data: linkTokenData } = useSWR(
    "plaidLinkToken",
    Accel.getPlaidLink(apiUrl, auth.access_token)
  );

  const { open, ready } = usePlaidLink({
    token: linkTokenData?.link_token!,
    onSuccess: (publicToken, metadata) => {
      Accel.putPlaidAccounts(apiUrl, auth.access_token, {
        params: { companyId, public_token: publicToken },
      });
      Accel.getPlaidTransactions(apiUrl, auth.access_token, {
        params: { companyId },
      });
     
    },
    // Add other necessary Plaid Link configurations
  });

  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Button
        variant="outlined"
        fullWidth
        sx={{
          width: "100%",
          height: "100%",
          color: theme?.text?.hex || "#000000",
          borderColor: theme?.secondary?.hex || "#000000",
        }}
        onClick={() => ready && open()}
        disabled={!ready}
      >
        + Add Account
      </Button>
    </Grid>
  );
};

export default ConnectBankAccount;
